import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { CreateOutputsCollectionComponent } from 'src/app/components/home/output-collections/actions/create-outputs-collection.component';
import { WarningModalComponent } from 'src/app/components/shared/warning-modal/warning-modal.component';

@Component({
  selector: 'app-release-collection-action',
  templateUrl: './release-collection-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ReleaseCollectionActionComponent {
  @Input() selectedProducts: IProduct[] = [];
  @Input() organizationId!: string;
  @Input() batchId!: string;

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  onRelease(): void {
    const listProductCanNotDownload: IProduct[] = [];
    const listProductCanDownload: IProduct[] = [];

    let includesReviewActive: boolean = false;
    let includesReleasedProducts: boolean = false;

    this.selectedProducts.forEach((s) => {
      if (s.approvedOutputAssetCount != 0 && s.expectedOutputAssetCount > 0) {
        listProductCanDownload.push(s);
      } else {
        includesReviewActive = true;
        listProductCanNotDownload.push(s);
      }

      if (s.releasedInCollection) {
        includesReleasedProducts = true;
      }
    });

    if (listProductCanDownload.length > 0) {
      if (includesReviewActive || includesReleasedProducts) {
        this.handleOutputsCollectionCreate(
          listProductCanDownload,
          listProductCanNotDownload,
          includesReviewActive,
          includesReleasedProducts,
        );
      } else {
        this.dialog.open(CreateOutputsCollectionComponent, {
          data: {
            organizationId: this.organizationId,
            batchId: this.batchId,
            isBatch: false,
            productIds: listProductCanDownload.map((s) => s.id),
          },
        });
      }
    } else {
      this.dialog.open(WarningModalComponent, {
        data: {
          header: 'Warning',
          content: 'There are no approved products. Please check again!',
        },
      });
    }
  }

  private handleOutputsCollectionCreate(
    listProductCanDownload: IProduct[],
    listProductCanNotDownload: IProduct[],
    incompleteProducts: boolean,
    includesReleasedProducts: boolean,
  ): void {
    const barcodes = listProductCanNotDownload.map((x) => x.barcode);

    if (incompleteProducts && includesReleasedProducts) {
      const dialogRef = this.dialog.open(WarningModalComponent, {
        data: {
          header: 'Warning',
          content: `1 or more products have not been included as they are not fully complete: ${barcodes.toString()}`,
          titleButtonOk: 'Continue',
          titleButtonNo: 'Cancel',
          showBtnNo: true,
        },
      });

      dialogRef.afterClosed().subscribe((res) => {
        if (res.ok == true) {
          const dialogRef2 = this.dialog.open(WarningModalComponent, {
            data: {
              header: 'Warning',
              content: '1 or more products have already been released. Would you like to re-release?',
              titleButtonOk: 'Continue',
              titleButtonNo: 'Cancel',
              showBtnNo: true,
            },
          });
          dialogRef2.afterClosed().subscribe((res2) => {
            if (res2.ok == true) {
              this.openCreateOutputsCollectionDialog(listProductCanDownload);
            }
          });
        }
      });
    } else if (incompleteProducts) {
      const dialogRef = this.dialog.open(WarningModalComponent, {
        data: {
          header: 'Warning',
          content: `1 or more products have not been included as they are not fully complete: ${barcodes.toString()}`,
          titleButtonOk: 'Continue',
          titleButtonNo: 'Cancel',
          showBtnNo: true,
        },
      });

      dialogRef.afterClosed().subscribe((res) => {
        if (res.ok == true) {
          this.openCreateOutputsCollectionDialog(listProductCanDownload);
        }
      });
    } else if (includesReleasedProducts) {
      const dialogRef = this.dialog.open(WarningModalComponent, {
        data: {
          header: 'Warning',
          content: '1 or more products have already been released. Would you like to re-release?',
          titleButtonOk: 'Continue',
          titleButtonNo: 'Cancel',
          showBtnNo: true,
        },
      });

      dialogRef.afterClosed().subscribe((res) => {
        if (res.ok == true) {
          this.openCreateOutputsCollectionDialog(listProductCanDownload);
        }
      });
    }
  }

  private openCreateOutputsCollectionDialog(products: IProduct[]): void {
    this.dialog.open(CreateOutputsCollectionComponent, {
      data: {
        organizationId: this.organizationId,
        batchId: this.batchId,
        isBatch: false,
        productIds: products.map((s) => s.id),
      },
    });
  }
}
